import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getStorage } from "util/localstorage";
export default function PrivateRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        getStorage("token_erp") ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/auth/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
